module.exports = __webpack_public_path__ + "cb7585ebf166d47817b55fbc7e080909.jpg";